module.exports = __webpack_public_path__ + "static/media/screenshots.134bce7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/videos/screenshots.mp4
// module id = B10k
// module chunks = 0